export default __webpack_public_path__ + "static/media/PawOnlyLogo.0d021d9c.png";